<script setup></script>

<template>
  <div class="base-gradient text-primary py-8 md:py-24 sm:px-2 lg:px-4 text-md">
    <div class="mx-auto max-w-7xl px-6">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-3xl font-bold tracking-tight">
            {{ $t('landingPage.aboutUsSection.title') }}
          </h2>
        </div>

        <div class="mt-16 grid lg:grid-cols-3 grid-cols-1 gap-x-24 gap-y-10">
          <div class="lg:col-span-2">
            <h3 class="text-2xl font-bold tracking-tight">
              {{ $t('landingPage.aboutUsSection.block1.title') }}
            </h3>
            <p class="mt-8">
              {{ $t('landingPage.aboutUsSection.block1.text') }}
            </p>
          </div>
          <div>
            <!-- Image section -->
          </div>
        </div>
        <div class="mt-16 grid lg:grid-cols-3 grid-cols-1 gap-x-24 gap-y-10">
          <div class="lg:col-span-2">
            <h3 class="text-2xl font-bold tracking-tight">
              {{ $t('landingPage.aboutUsSection.block2.title') }}
            </h3>
            <p class="mt-8">
              {{ $t('landingPage.aboutUsSection.block2.text') }}
            </p>
          </div>
          <div class="flex justify-center">
            <!-- Image section -->
            <img
              src="../../assets/gamebook-services_logo_transp.png"
              alt="GameBook Services Logo Transparent"
              class="aspect-[2/2] w-60 h-60"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
